import React from 'react';
import Button from '../../../../components/ui/Button';
import Icon from '../../../../components/AppIcon';

const ResendCodeButton = ({ canResend, onResend, loading }) => {
  return (
    <div className="text-center">
      {canResend ? (
        <div className="space-y-2">
          <Button
            onClick={onResend}
            disabled={loading}
            loading={loading}
            variant="outline"
            size="sm"
            className="text-primary border-primary hover:bg-primary hover:text-white"
          >
            <Icon name="RefreshCw" size={16} className="mr-2" />
            {loading ? 'Sending...' : 'Resend Code'}
          </Button>
          <p className="text-xs text-accent-500">
            Didn't receive the code? We can send a new one.
          </p>
        </div>
      ) : (
        <p className="text-xs text-accent-500">
          You can request a new code after the timer expires.
        </p>
      )}
    </div>
  );
};

export default ResendCodeButton;